export enum UserRoles {
    None = 1,
    Estimator,
    SalesPerson,
    Manager,
    SalesAdmin,
    OrganizationAdmin,
    UserAdmin,
    GlobalAdmin
}
